import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { LOGOUT_CONFIRMATION_DIALOG } from "@/constants/dialog-constants";
import { RootState } from "@/store/store";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "@/store/reducers/dialogReducer";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
import DialogLoaderButton from "../loader-button/DialogLoaderButton";
import { unauthenticate } from "@/store/reducers/authReducer";
import { NavigationRoutes } from "../navigation/constants";

const LogoutConfirmationDialog: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isOpen, dialogType } = useSelector(
    (state: RootState) => state.dialog
  );
  const isOpened = isOpen && dialogType === LOGOUT_CONFIRMATION_DIALOG;

  const handleClose = () => {
    dispatch(closeDialog());
  };
  const handleLogout = () => {
    dispatch(unauthenticate());
    dispatch(closeDialog());
    navigate(NavigationRoutes.ROOT);
    localStorage.clear();
  };

  return (
    <Dialog open={isOpened} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Deconnexion</DialogTitle>
          <DialogDescription>
            Étes-vous sûr de vouloir vous déconnecter ?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col sm:flex-row gap-2 sm:gap-0">
          <Button variant="outline" className="mr-2" onClick={handleClose}>
            Annuler
          </Button>
          <DialogLoaderButton
            name="Déconnexion"
            handleSubmit={handleLogout}
            isLoading={false}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmationDialog;
